export default __webpack_public_path__ + "static/media/LAC.f442b48b.svg";